export enum TaskSubject {
  TICKET_CLOSURE = '7. Ticketabschluss',
  OPL_EXT_EVALUATE_OFFERS_AND_CREATE_SUPPLIERS = '2. Einkauf einbinden und Direktanfrage durchführen',
  OPL_EXT_EVALUATE_OFFER_INQUIRY = '3. Angebotsanfrage erhalten und Angebot erstellen',
  OPL_EXT_EXECUTE_OPTIONAL_SERVICE = '7. Optionale Leistung ext. durchführen',
  OPL_EXT_SUBMIT_INVOICE_TO_SCAN_CENTER = '11. Rechnung an Scanzentrum übermitteln',
}
